import React, {useRef, useState} from 'react';
import BoxHeader from "../../components/box-header";
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import {DataView} from "primereact/dataview";
import Avatar from "../../../system/components/avatar";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import {colorToHexAlpha} from "../../../system/utils";
import {useProject} from "../../../models/project/use-project";
import {OverlayPanel} from "primereact/overlaypanel";
import MultiSelectProjects from "../../projects/components/multi-select-projects";
import {useSelector} from "react-redux";
import {Button} from "primereact/button";
import MultiSelectGoals from "../../goals/components/multi-select-goals";
import {ProgressBar} from "primereact/progressbar";
import {useGoal} from "../../../models/goal/use-goal";
import MultiSelectMembers from "../../tasks/components/multi-select-members";
import {useTeam} from "../../../models/team/use-team";
import TeamSettingsDialog from "../component/team-settings-dialog";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";
import Can from "../../../system/can";
import ProjectSidebar from "../../projects/components/project-sidebar";
import GoalSidebar from "../../goals/components/goal-sidebar";
import {useNavigate} from "react-router-dom";
import {prepareTeamMemberRows} from "../team-members";
import {teamDisplayName} from "../team-display-name";
import {RichTextView, richTextToPlain} from "../../../system/components/rich-text";

function Identification({teamData, onChange, onArchived}) {
    const team = useTeam();

    const updateTeam = async (teamData, updateData)=>{
        let _data = await team.updateTeam(teamData.documentId, updateData);
        onChange?.(_data);
    }
    const modifyMembers = (data)=>{
        if (data?.status==="added"){
            updateTeam(teamData, {members:{connect:[data.member.documentId || data.member.id]}})
        }
        if (data?.status==="removed"){
            updateTeam(teamData, {members:{disconnect:[data.member.documentId || data.member.id]}})
        }
    }
    const modifyProjects = (data)=>{
        if (data?.status==="added"){
            updateTeam(teamData, {projects:{connect:[data.projectData.documentId || data.projectData.id]}})
        }
        if (data?.status==="removed"){
            updateTeam(teamData, {projects:{disconnect:[data.projectData.documentId || data.projectData.id]}})
        }
    }
    const modifyGoals = (data)=>{
        if (data?.status==="added"){
            updateTeam(teamData, {goals:{connect:[data.goalData.documentId || data.goalData.id]}})
        }
        if (data?.status==="removed"){
            updateTeam(teamData, {goals:{disconnect:[data.goalData.documentId || data.goalData.id]}})
        }
    }



    return (
        <div className="h-full surface-50 overflow-auto">
            <div className="flex flex-column p-3 gap-3">
                <CardView className="p-3 bg-white">
                    <Description teamData={teamData} onSubmit={onChange} onArchived={onArchived}/>
                </CardView>
                <div className="flex flex-column lg:flex-row gap-3">
                    <div className="flex flex-column flex-1 gap-3">
                        <CardView className="p-3 bg-white">
                            <TeamConfigCompleteProgress teamData={teamData}/>
                        </CardView>
                        <CardView className="p-3 bg-white">
                            <TeamRules teamData={teamData}/>
                        </CardView>
                        <CardView className="p-3 bg-white">
                            <TeamGoals teamData={teamData} onChange={(e)=>{modifyGoals(e)}}/>
                        </CardView>
                        <CardView className="p-3 bg-white">
                            <TeamProjects teamData={teamData} onChange={(e)=>{modifyProjects(e)}}/>
                        </CardView>
                    </div>
                    <div className="flex flex-column w-full lg:w-4 h-fit">
                        <CardView className="p-3 bg-white">
                            <TeamMembers teamData={teamData} onChange={(e)=>{modifyMembers(e)}}/>
                        </CardView>
                    </div>
                </div>
            </div>
        </div>
    );
}

const Description = ({teamData, onSubmit, onArchived})=>{
    const [teamSettingsDialogVisible, setTeamSettingsDialogVisible] = useState();
    const translate = useTranslate()
    return(
        <div className="flex gap-3">
            <div className="flex align-items-center justify-content-center border-round-lg w-4rem h-4rem " style={{backgroundColor:colorToHexAlpha(teamData?.iconColor?.color, 0.1),color:colorToHexAlpha(teamData?.iconColor?.color, 1)}}>
                <Icon className="text-6xl" icon={teamData?.iconColor?.icon||"mi mi:groups"}/>
            </div>

            <div className="flex flex-column">
                <div className="flex align-items-center gap-2">
                    <span className="text-4xl font-bold">{`${translate("team")} ${teamDisplayName(teamData, translate)}`}</span>
                    <Can permission="manage-teams">
                        <Button onClick={()=>{setTeamSettingsDialogVisible(true)}} className="p-button-sm p-button-text shadow-none outline-none text-xs p-1 px-2 gap-1" icon={<Icon icon="mi mi:settings" className="text-sm"/>} label={translate("team-settings")} />
                    </Can>
                </div>
                <RichTextView className="m-0 text-xs text-500" value={teamData?.description} empty={<p className="m-0 text-xs text-500">{translate("team.description.empty")}</p>}/>
            </div>
            <TeamSettingsDialog setVisible={setTeamSettingsDialogVisible} visible={teamSettingsDialogVisible} teamData={teamData} onArchived={onArchived} onSubmit={()=>{onSubmit?.(); setTeamSettingsDialogVisible(false)}}/>
        </div>

    )
}
const TeamGoals = ({teamData, onChange})=>{
    const translate = useTranslate();
    const ref = useRef()
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const goal = useGoal();
    const [goalData, setGoalData] = useState();


    const ItemTemplate = (data)=>{

        return(
            <div className="p-2 w-full">
                <div className="surface-50 border-round flex align-items-center p-3 justify-content-between cursor-pointer" onClick={()=>{setGoalData(data)}}>
                    <span className="text-xs font-bold">{data?.title}</span>
                    <div className="flex align-items-center gap-3">
                        <ProgressBar className="w-10rem h-1rem text-2xs" showValue value={Number(data?.progress?.value ?? data?.progress ?? 0)}/>
                        <span className={`text-xs ${goal.statusClassName(data?.goalStatus, true, true)}`}>{translate(data.goalStatus)}</span>
                        <Avatar memberData={data?.owner?.member}/>
                    </div>
                </div>
            </div>
        )
    }
    return(
        <div className="flex flex-column">
            <BoxHeader left={<Can permission="manage-teams"><Button className="text-xs p-button-text border-none shadow-none flex gap-1" icon={<Icon icon="mi mi:add_circle" className="text-lg"/>} label={translate("add-goals")} onClick={(e)=>{ref.current.toggle(e)}}/></Can>} icon={<Icon icon="mi mi:flag" className="text-red-500"/>} title={translate("key-goals")}/>
            <DataView emptyMessage={<DatatableEmptyMessage/>} value={teamData?.goals||[]} layout="grid" itemTemplate={ItemTemplate}/>
            <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                <MultiSelectGoals onChange={onChange} options={workspaceMembershipData?.workspace?.goals?.filter(p=>!p.team||p.team?.documentId===teamData?.documentId)} value={teamData?.goals}/>
            </OverlayPanel>
            <GoalSidebar setGoalData={setGoalData} goalData={goalData} onHide={()=>{setGoalData(undefined)}}/>
        </div>

    )
}
const TeamProjects = ({teamData, onChange})=>{
    const translate = useTranslate();
    const project = useProject();
    const ref = useRef()
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const [projectData, setProjectData] = useState();
    const ItemTemplate = (data)=>{
        return(
            <div className="p-2 w-3">
                <div className="surface-50 h-14rem border-round flex flex-column p-3 gap-2 border-1 border-300 border-round-2xl cursor-pointer" onClick={()=>{setProjectData(data)}}>
                    <div className="flex align-items-center justify-content-between w-full">
                        <PrimeAvatar  size="normal" style={{backgroundColor:colorToHexAlpha(data?.color_icon?.color, 0.1),color:colorToHexAlpha(data?.color_icon?.color, 1)}} icon={<Icon icon={data?.color_icon?.icon||"mi mi:work"} className="text-lg"/>}/>
                        <span className={`text-xs ${project.statusClassName(data?.projectStatus, true, true)}`}>{translate(data.projectStatus)}</span>
                    </div>
                    <span className="text-xs font-bold">{data?.title}</span>
                    <span className="text-xs text-400 overflow-hidden" style={{display: "-webkit-box", WebkitLineClamp: 4, WebkitBoxOrient: "vertical"}}>{richTextToPlain(data?.description)}</span>
                </div>
            </div>
        )
    }
    return(
        <div className="flex flex-column">
            <BoxHeader left={<Can permission="manage-teams"><Button className="text-xs p-button-text border-none shadow-none flex gap-1" icon={<Icon icon="mi mi:add_circle" className="text-lg"/>} label={translate("add-project")} onClick={(e)=>{ref.current.toggle(e)}}/></Can>} title={translate("projects")}/>
            <DataView emptyMessage={<DatatableEmptyMessage/>} value={teamData?.projects||[]} layout="grid" itemTemplate={ItemTemplate}/>
            <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                <MultiSelectProjects onChange={onChange} options={workspaceMembershipData?.workspace?.projects?.filter(p=>!p.team||p.team?.documentId===teamData?.documentId)} value={teamData?.projects}/>
            </OverlayPanel>
            <ProjectSidebar onHide={()=>{setProjectData(undefined)}} projectData={projectData} setProjectData={setProjectData}/>
        </div>
    )
}
const TeamMembers = ({teamData, onChange})=>{
    const translate = useTranslate();
    const ref = useRef();
    const navigate = useNavigate();
    const memberships = prepareTeamMemberRows(teamData?.members, "", teamData?.owner);


    const ItemTemplate = (data)=>{
        return(
            <div className="p-2 w-full">
                <div className="surface-50 border-round flex align-items-center p-2 gap-2 cursor-pointer"
                    onClick={() => data?.member?.documentId && navigate(`/user-profile/${data.member.documentId}`)}>
                    <Avatar memberData={data?.member}/>
                    <span className="text-xs font-bold">{data?.member?.fullname || translate("team.member.unknown")}</span>
                </div>
            </div>
        )
    }
    return(
        <div className="flex flex-column">
            <BoxHeader left={<Can permission="manage-teams"><Button aria-label={translate("invite-member")} className="text-xs p-button-text border-none shadow-none flex gap-2" icon={<Icon icon="mi mi:person_add" className="text-lg"/>} onClick={(e)=>{ref.current.toggle(e)}}/></Can> } icon={<Icon icon="mi mi:group" className="text-red-500"/>}  title={`${translate("team-members")} (${memberships.length})`}/>
            <DataView emptyMessage={<DatatableEmptyMessage/>} value={memberships} layout="list" itemTemplate={ItemTemplate}/>
            <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                <MultiSelectMembers onChange={onChange} value={memberships}/>
            </OverlayPanel>
        </div>

    )
}

const TeamRules = ({teamData}) => {
    const translate = useTranslate();
    const rules = Array.isArray(teamData?.teamRules) ? teamData.teamRules : [];
    return <div className="flex flex-column">
        <BoxHeader icon={<Icon icon="mi mi:edit_document" className="text-primary"/>} title={translate("team-rules")}/>
        {!rules.length ? <p className="text-center text-500 py-3">{translate("team-rules-empty")}</p> : <div className="grid p-2">
            {rules.map((rule, index) => <article key={rule?.id || index} className="col-12 md:col-6">
                <div className="h-full surface-50 border-1 border-100 border-round-xl p-3">
                    <strong className="block mb-2">{rule?.title || `${translate("team-rules")} ${Number(index + 1).toLocaleString("fa-IR")}`}</strong>
                    <ul className="m-0 pr-3 line-height-3">
                        {(rule?.items || []).filter(Boolean).map((item, itemIndex) => <li key={itemIndex}>{typeof item === "string" ? item : item?.text}</li>)}
                    </ul>
                </div>
            </article>)}
        </div>}
    </div>;
};

function CardView({children, className, onClick}){
    return (
        <div onClick={onClick} className={`${className} h-full text-xs w-full shadow-1 border-round-xl ${onClick&&"cursor-pointer hover:surface-50"}`}>
            {children}
        </div>
    )
}

function TeamConfigCompleteProgress({teamData}) {
    const translate = useTranslate();
    let teamProgress = 1;
    if (teamData?.description) teamProgress+=1;
    if (teamData?.members?.length>0) teamProgress+=1;
    if (teamData?.goals?.length>0) teamProgress+=1;
    if (teamData?.projects?.length>0) teamProgress+=1;

    return(
        <div className="flex flex-column">
            <BoxHeader title={translate("team-complete-progress")}/>
            <div className="flex flex-column gap-2 p-3">
                <div className="flex align-items-center justify-content-between">
                    <span>{translate("steps-progress").replace("{{STEPS}}",5).replace("{{STEP}}",teamProgress)}</span>
                    <span>{teamProgress*20}%</span>
                </div>
                <ProgressBar className="w-full h-1rem text-2xs" showValue={true} value={teamProgress*20}/>
                <div className="flex justify-content-between align-items-center pt-2">
                    <div className="flex flex-column gap-2 align-items-center justify-content-center">
                        <PrimeAvatar className="bg-cyan-100 text-cyan-500" size="large" shape="circle" icon={<Icon icon="mi mi:check"/>}/>
                        <span>{translate("create-team")}</span>
                    </div>
                    <div className="flex flex-column gap-2 align-items-center justify-content-center">
                        <PrimeAvatar className={`${teamData?.description?"bg-cyan-100 text-cyan-500":"bg-red-100 text-red-500"}`} size="large" shape="circle" icon={<Icon icon={`mi mi:${teamData?.description?"check":"description"}`}/>}/>
                        <span>{translate("add-description")}</span>
                    </div>
                    <div className="flex flex-column gap-2 align-items-center justify-content-center">
                        <PrimeAvatar className={`${teamData?.members?.length>0?"bg-cyan-100 text-cyan-500":"bg-red-100 text-red-500"}`} size="large" shape="circle" icon={<Icon icon={`mi mi:${teamData?.members?.length>0?"check":"person_add"}`}/>}/>
                        <span>{translate("invite-members")}</span>
                    </div>
                    <div className="flex flex-column gap-2 align-items-center justify-content-center">
                        <PrimeAvatar className={`${teamData?.goals?.length>0?"bg-cyan-100 text-cyan-500":"bg-red-100 text-red-500"}`} size="large" shape="circle" icon={<Icon icon={`mi mi:${teamData?.goals?.length>0?"check":"flag"}`}/>}/>
                        <span>{translate("add-goals")}</span>
                    </div>
                    <div className="flex flex-column gap-2 align-items-center justify-content-center">
                        <PrimeAvatar className={`${teamData?.projects?.length>0?"bg-cyan-100 text-cyan-500":"bg-red-100 text-red-500"}`} size="large" shape="circle" icon={<Icon icon={`mi mi:${teamData?.projects?.length>0?"check":"work"}`}/>}/>
                        <span>{translate("add-projects")}</span>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default Identification;
